import React from 'react';
import styles from './FormContainer.module.scss';

export const FormContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.formContainer}>{children}</div>;
};
